import React, { useEffect, useState } from "react";
import Manubar from "./Manubar";
import Security from "./Security";
import Footer from "./Footer";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import axios from "axios";
import "./loader.css";

const PrivacyAndPolicy = () => {

  const [privacy, setPrivacy] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getPrivacy() {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API}website/privacy_policy`
      );

      setPrivacy(res.data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getPrivacy();
  }, []);

  return (
    <div>

      {/* Mobile Menu */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      {/* Header */}
      <header>
        <Shearchbar />
        <Navbar />
      </header>

      {/* Breadcrumb */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">
                  Privacy & Policy
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Content Section with Hidden Scrollbar */}
      <section className="about-section section-mt section-mb">
        <div className="container">
          <div className="row mb-n7 align-items-center">
            <div className="col-xl-6 mb-7">

              <div className="about-content">

                {loading ? (

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "200px"
                    }}
                  >
                    <div className="loader"></div>
                  </div>

                ) : (

                  <div 
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      scrollbarWidth: "none",  /* Firefox ke liye */
                      msOverflowStyle: "none",  /* IE aur Edge ke liye */
                      scrollBehavior: "smooth"
                    }}
                  >
                    {privacy.map((item, idx) => (
                      <div key={idx}>
                        <h2 className="title mb-5">
                          {item?.title}
                        </h2>
                        <p className="mb-5 text-start">
                          {item?.description}
                        </p>
                      </div>
                    ))}
                  </div>

                )}

              </div>

            </div>
          </div>
        </div>
      </section>

      <Security />
      <Footer />

    </div>
  );
};

export default PrivacyAndPolicy;